module.exports = __webpack_public_path__ + "fonts/TTFirs-ExtraBold.c9576c37.woff";